import script from "./StudentTrackingPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentTrackingPanel.vue?vue&type=script&setup=true&lang=js"

import "./StudentTrackingPanel.vue?vue&type=style&index=0&id=f8dc190c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f8dc190c"]])

export default __exports__